import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

const mapStateToProps = (state) => {
  const { currentUser } = state.user
  return { currentUser }
}

class MenuItemAccount extends React.Component {
  render() {
    const { currentUser } = this.props
    const accountType = currentUser.id ? currentUser.user_type : 'visitor'
    return accountType !== 'visitor' ? (
      <Menu.Menu position="right">
        <Menu.Item>
          <span>
            <Icon name="user outline" />
            <span className="hide-below-tablet">{currentUser.email}</span>
          </span>
        </Menu.Item>
      </Menu.Menu>
    ) : (
      false
    )
  }
}

MenuItemAccount = connect(mapStateToProps)(MenuItemAccount)
export default MenuItemAccount



// WEBPACK FOOTER //
// ./src/components/shared/Header/menuItems/MenuItemAccount.jsx